import options from './specific-time.component';

export default {
    selector: 'dtSpecificTime',
    options
};



// WEBPACK FOOTER //
// ./app/components/alerts-actions/alerts-actions-content/time-period/specific-time/index.js